module.exports = __webpack_public_path__ + "assets/img/memo-design-2.5a6674e3.png";